import axios from 'utils/axios';
import { put } from 'redux-saga/effects';
import { convertNumberToEmployeesConstant } from "utils/helpers.js"
import { toastr } from 'react-redux-toastr'
import i18n from 'i18n/i18n.js';
import * as Company from 'actions/Company';

export function* onGetDetailCompanyRequest({params, cb}) {
  try {
    const res = yield axios.get(`/api/company/${params}`);
    yield put(Company.onGetDetailSuccess(res.data || []));
    if (res.data.companyId) {
      cb && cb(res.data.companyId);
    }
  } catch (e) {
    yield put(Company.onGetDetailFailure({ message: e }));
  }
}

export function* onGetAllCompanyRequest() {
  try {
    const res = yield axios.get('/api/company/getAll');
    yield put(Company.onGetAllSuccess(res.data || []));
  } catch (e) {
    yield put(Company.onGetAllFailure({ message: e }));
  }
}

export function* onGetFeedRequest({ payload }) {
  try {
    const { data } = yield axios.get(`/api/company/feed/posts/${payload.companyId}?size=${payload.size || 20}&page=${payload.page || 0}`);
   
    yield put(Company.onGetFeedSuccess({
      list: data || [],
      ...payload,
    }));

  } catch (error) {
    yield put(Company.onGetFeedFailure({ message: error }));
  }
}

export function* onGetCompanyFollowersRequest({ payload }) {
  try {
    const { data } = yield axios.get(`/api/company/${payload.companyId}/getCompanyFollowers?size=${payload.size || 20}&page=${payload.page || 0}`);
   
    yield put(Company.onGetCompanyFollowersSuccess(data));

  } catch (error) {
    yield put(Company.onGetCompanyFollowersFailure({ message: error }));
  }
}

export function* onCreateCompanyPostRequest({ payload }) {
  try {
		const data = new FormData();

		// Company
		data.append('postType', payload.postType);
		data.append('title', payload.title);
		data.append('description', payload.description);	
		data.append('image', payload.image);

    const res = yield axios.post('/api/companyPost/createCompanyPost', data);

    yield put(Company.onCreateCompanyPostSuccess(res.data || []));
  } catch (e) {
    yield put(Company.onCreateCompanyPostFailure({ message: e }));
  }
}

export function* onCreateUserRequest({ payload }) {
  try {
    const res = yield axios.post('/api/companyUser/createCompanyUser', payload);

    yield put(Company.onCreateUserSuccess(res.data || []));
    toastr.success(i18n.t('toastr.onCreateUserSuccess.title'), i18n.t('toastr.onCreateUserSuccess.body'))

  } catch (e) {
    yield put(Company.onCreateUserFailure({ message: e }));
  }
}

export function* onUpdateCompanyRequest({ payload }) {
	try {
		const data = new FormData();

    // Company
    data.append('companyName', payload.companyName);
    data.append('about', payload.about);
    data.append('numberOfEmployees', payload.employees);
    data.append('revenue', payload.revenue)
		data.append('headQuarters', payload.headquarter);	
    data.append('founded', payload.founded);
		data.append('homepage', payload.homepage);
    if(payload.logo) {
      data.append('companyLogo', payload.logo);
    }
      
    const { data: rs } = yield axios.post('/api/company/update', data);

    yield put(Company.onUpdateCompanySuccess(rs));
    toastr.success(i18n.t('toastr.onUpdateCompanySuccess.title'), i18n.t('toastr.onUpdateCompanySuccess.body'))

	} catch (e) {
    yield put(Company.onUpdateCompanyFailure({ message: e.toString() }));
	}
}

export function* onUpdateCompanyUserRequest({ payload }) {
	try {
		const data = new FormData();

    // Company
    data.append('firstName', payload.firstName);
    data.append('lastName', payload.lastName);
    data.append('profession', payload.profession)
		data.append('phone', payload.phone);	
    data.append('aboutMe', payload.aboutMe);
    if(payload.profilePicture) {
      data.append('profilePicture', payload.profilePicture);
    }
      
    const { data: rs } = yield axios.post('/api/companyUser/update', data);

    yield put(Company.onUpdateCompanyUserSuccess(rs));
    toastr.success(i18n.t('toastr.onUpdateCompanyUserSuccess.title'), i18n.t('toastr.onUpdateCompanyUserSuccess.body'))

	} catch (e) {
    yield put(Company.onUpdateCompanyUserFailure({ message: e.toString() }));
	}
}

export function* onUpdateCompanyCoverImageRequest({ payload }) {
	try {
		const data = new FormData();

    data.append('headerLogo', payload.image);
      
    const { data: rs } = yield axios.post('/api/company/updateHeaderLogo', data);

    yield put(Company.onUpdateCompanyCoverImageSuccess(rs));
    // toastr.success(i18n.t('toastr.onUpdateCompanySuccess.title'), i18n.t('toastr.onUpdateCompanySuccess.body'))

	} catch (e) {
    yield put(Company.onUpdateCompanyCoverImageFailure({ message: e.toString() }));
	}
}

export function* onDeleteHitPostRequest({ payload }) {

  const { entityId, entityType } = payload;

  try {
    const res = yield axios.delete('/api/company/feed/posts/delete', { data: { entityId: entityId, entityType: entityType }});
    yield put(Company.onDeleteHitPostSuccess(payload));
  } catch (e) {
    yield put(Company.onDeleteHitPostFailure({ message: e }));
  }
}

export function* onConnectCompanyInstagramRequest({ params, cb }) {
  try {
      const rs = yield axios.post(`/api/company/connectInstagram`, params);
      yield put(Company.onConnectInstagramSuccess(rs.data || {}));
      cb && cb(null, rs.data);
  } catch (e) {
      console.log('Error: onConnectInstagramRequest', e);
      yield put(Company.onConnectInstagramFailure());
      cb && cb(e);
  }
}

export function* onDeleteInstagramRequest({ params, cb }) {
  try {
      const rs = yield axios.delete(`/api/company/deleteInstagram`, {data: params});
      yield put(Company.onDeleteInstagramSuccess(rs.data || {}));
      cb && cb(null, rs.data);
  } catch (e) {
      console.log('Error: onDeleteInstagramRequest', e);
      yield put(Company.onDeleteInstagramFailure());
      cb && cb(e);
  }
}

export function* onGetCompanyHitEventsRequest({ params, cb }) { 
  const { companyId, page, size, q, orderBy, orderDirection, fromDate } = params;

  try {
    const res = yield axios.get(`/api/company/${companyId}/allHitEvents?page=${page || 0}&size=${size || 10}${q ? `&q=${q}` : ''}${fromDate ? `&fromDate=${fromDate}` : ''}${orderBy ? '&sort=' + orderBy + ',' + orderDirection : ''}`);
    yield put(Company.onGetCompanyHitEventsSuccess(res.data));

    cb && cb(null);
  } catch (e) {
    console.log('Error: onGetCompanyHitEventsRequest', e);
    yield put(Company.onGetCompanyHitEventsFailure({ message: e.toString() }));
    cb && cb(e);
  }
}